import { ToggleButtonGroup } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import React, { useEffect } from 'react';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import PropTypes from 'prop-types';
import FieldLabelAndError from './FieldLabelAndError';
import { ErrorMessage } from './ErrorMessage';
import { requiredUtil } from '../utils';

/* eslint-disable no-unused-vars */
const GenericToggleButtonGroupField = ({
    name,
    label,
    inlineLabel,
    inlineLabelCss,
    className,
    onChange,
    value,
    disabled,
    required,
    clearOnUnmount,
    ...otherProps
}) => {
    const form = useForm();
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (clearOnUnmount) {
            return () => form.change(name);
        }
    }, [clearOnUnmount]);

    const inputcss = className || 'h-4 md:h-6';
    return (
        <Field name={name} validate={required ? requiredUtil : undefined}>
            {({ input, meta }) => (
                <div className="mb-3">
                    {label && (
                        <FieldLabelAndError label={label} required={required} />
                    )}

                    <div className="block md:flex pt-2 justify-between md:pl-1">
                        <div
                            className={
                                inlineLabelCss ||
                                'text-gray-700 mb-1 md:mb-0 pl-1'
                            }
                        >
                            {inlineLabel}{' '}
                            {required && (
                                <span className="text-sm text-red-500 my-0 md:mb-0">
                                    *{' '}
                                </span>
                            )}
                        </div>
                        <div className="grid grid-rows-2 md:pl-4">
                            <ToggleButtonGroup
                                {...input}
                                onChange={(__, val) => {
                                    if (!_.isNull(val)) {
                                        input.onChange(val); // updating form's input selection
                                        if (onChange) {
                                            // executing callback handler, if provided
                                            onChange(val);
                                        }
                                    }
                                }}
                                className={inputcss}
                                exclusive
                                data-testid={name}
                            >
                                {otherProps.options.map((option) => (
                                    <ToggleButton
                                        value={option.value}
                                        key={option.value}
                                    >
                                        {option.label}
                                    </ToggleButton>
                                ))}
                            </ToggleButtonGroup>
                            <ErrorMessage meta={meta} />
                        </div>
                    </div>
                </div>
            )}
        </Field>
    );
};

GenericToggleButtonGroupField.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    inlineLabel: PropTypes.string,
    inlineLabelCss: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    clearOnUnmount: PropTypes.bool,
    otherProps: PropTypes.any,
};

export default GenericToggleButtonGroupField;
